import { getCerebroHeaders } from 'api/Cerebro/headers'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { Report } from 'types'

import { BannerRequestBody } from './types'

export const getCampaignPlacementFacts = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post(
        '/api/campaign_placement_facts/aggregate/banner/',
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )

export const getCampaignPlacementFactsExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/campaign_placement_facts/aggregate/banner/export/',
        params
    )
